import React from "react";
import classes from "./Steppers.module.scss";
import { useTranslation } from "react-i18next";

export default function Steppers({
  stage = 1,
  steppes = null,
  showLabels = true,
  horizontal = false,
  checkAll = false,
  showInsideLabel = false,
  showBottonInfo = false,
}: {
  stage: number;
  steppes: Array<any> | null;
  showLabels?: boolean;
  horizontal?: boolean;
  checkAll?: boolean;
  showInsideLabel?: boolean;
  showBottonInfo?: boolean;
}) {
  const { t } = useTranslation();

  const getStep = (stage: number, steppes: Array<any>) => {
    let activeIndex = 0;
    return steppes.map((step, index) => {
      let finalClass = classes.Infos;
      if (showInsideLabel) finalClass = classes.BiggerDotInfos;

      if (stage === index + 1 || (checkAll && ++activeIndex < stage)) {
        finalClass += " " + classes.Active;
        finalClass += " " + classes.CheckAll;
      }
      return (
        <p className={finalClass} key={step + index}>
          <span className={!showInsideLabel ? classes.Dot : classes.BiggerDot}>
            {showInsideLabel && <div>{t(step)}</div>}
          </span>
        </p>
      );
    });
  };

  let _content = null;
  if (steppes) {
    let steppesClassName = classes.Stepper;
    if (horizontal) steppesClassName += " " + classes.Horizontal;
    _content = (
      <>
        <div className={steppesClassName}>{getStep(stage, steppes)}</div>
        {showInsideLabel && <div className={classes.StepperItem}>
          <div style={{ textAlign: "left" }}>{t("purchase.quantity")}</div>
          <div>{t("purchase.invoice_data")}</div>
          <div style={{ textAlign: "right" }}>{t("purchase.payment")}</div>
        </div>}
      </>
    );
  }
  return _content;
}
